import "./path0.6aa9045e.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire383b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire383b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

function $b8e032c449ce363f$var$CubeButton({ children: children, href: href }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: href,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            className: "btn cube cube-hover",
            type: "button",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg-top",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-inner"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg-right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-inner"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-inner"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text",
                    children: children
                })
            ]
        })
    });
}
function $b8e032c449ce363f$var$App() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "app-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "cinzel-regular",
                children: "Zev Pinker"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                className: "nav-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b8e032c449ce363f$var$CubeButton, {
                        href: "/gravity.html",
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b8e032c449ce363f$var$CubeButton, {
                        href: "/portfolio.html",
                        children: "Portfolio"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b8e032c449ce363f$var$CubeButton, {
                        href: "/creative_portfolio.html",
                        children: "Creative"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("footer", {
                className: "social-links",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "https://www.linkedin.com/in/zev-pinker-69a680279/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "LinkedIn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "https://github.com/ZevPinker",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "GitHub",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "/resume.html",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "LinkedIn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("mask", {
                                        id: "cvMask",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                rx: "3",
                                                width: "24",
                                                height: "24",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                                                x: "12",
                                                y: "16.5",
                                                fontFamily: "Arial Black, sans-serif",
                                                fontSize: "11",
                                                fontWeight: "900",
                                                fill: "black",
                                                textAnchor: "middle",
                                                children: "CV"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    width: "24",
                                    height: "24",
                                    fill: "currentColor",
                                    mask: "url(#cvMask)"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
const $b8e032c449ce363f$var$root = (0, $aRPiL.createRoot)(document.getElementById('root'));
$b8e032c449ce363f$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($b8e032c449ce363f$var$App, {}));


//# sourceMappingURL=path0.0c54c073.js.map
